module.exports = __webpack_public_path__ + "img/contact_btn.db6a6913.svg";